/**
 * Created by hp on 2017/8/22.
 */
import React, { Component } from "react";
import axios from "axios";
import qs from "qs";
import qr from "qr-encode";
import {
  Button,
  CellBody,
  CellHeader,
  CellsTitle,
  Form,
  FormCell,
  Gallery,
  GalleryDelete,
  Input,
  Label,
  MediaBox,
  MediaBoxBody,
  MediaBoxDescriptio,
  MediaBoxHeader,
  MediaBoxTitle,
  PanelBody,
  TextArea,
  Uploader
} from "react-weui";
import { WKDialog } from "../../components";
import { ComplainContact } from "../complain";
import tsImg from "../../images/share-card-close.png";
import { getJsonFromUrl } from '../../utils/index'

class ComplainBody extends Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleReasonChange = this.handleReasonChange.bind(this);
    const { id, type } = this.props;
    let link = "";
    if (type === "lecture") {
      link = window.location.origin + `/lecture/${id}`;
    }
    if (type === "channel") {
      link = window.location.origin + `/channel/${id}`;
    }
    const { from } = getJsonFromUrl()
    this.state = {
      showDialog: false,
      qrcode: "",
      gallery: false,
      link,
      reason: "",
      demoFiles: [],
      pictures: [],
      from
    };
  }

  // 手机号验证
  validPhone(phone){
    return !!phone && /^1[0-9]{10}$/.test(phone);
  };

  handleSubmit() {
    const { link, reason, pictures, from } = this.state;
    const { id, type, category } = this.props;
    const { mobile, wechat_no } = this.refs.complainContact.getData();

    if (reason.trim() === "") {
      this.context.page.showAlert(`请输入${from === 'lihua'? '咨询':'投诉'}内容`);
      return;
    }
    if (pictures.length === 0 && from !== 'lihua') {
      this.context.page.showAlert("请上传证据截图");
      return;
    }

    if (this.props.isFromQuestion && !mobile) {
      this.context.page.showAlert("请填写手机号");
      return;
    }

    if (!this.validPhone(mobile)) {
      this.context.page.showAlert("请填写正确的手机号");
      return;
    }

    if (!wechat_no && !mobile) {
      this.context.page.showAlert(
        "为了保障您的问题能够更好的解决，请填写您的联系方式"
      );
      return;
    }

    let form = new FormData();
    if (type === "lecture") {
      form.append("lecture_id", id);
    }
    if (type === "channel") {
      form.append("channel_id", id);
    }
    form.append("category",from === 'lihua' ? 'lihuaguanwangtousu' : category);
    form.append("link", link);
    form.append("reason", reason);
    form.append("wechat_no", wechat_no);
    form.append("mobile", mobile);

    for (let i = 0; i < pictures.length; i++) {
      form.append("pictures[]", pictures[i]);
    }

    this.context.page.showToast("正在提交", "loading", false);
    axios.post("/api/complain/", form).then(res => {
      this.context.page.hideToast();
      if (res.data.code === 0) {
        this.setState({ showDialog: true, qrcode: res.data.data.qrcode });
      } else {
        this.context.page.showAlert(res.data.msg);
      }
    });
  }

  handleClose() {
    window.location = "/message/system";
  }

  handleReasonChange(e) {
    this.setState({ reason: e.target.value });
  }

  renderGallery() {
    if (!this.state.gallery) return false;

    return (
      <Gallery
        src={this.state.gallery.url}
        show
        onClick={e => {
          e.preventDefault();
          e.stopPropagation();
          this.setState({ gallery: false });
        }}
      >
        <GalleryDelete
          onClick={(e, id) => {
            this.setState({
              demoFiles: this.state.demoFiles.filter(
                (e, i) => i != this.state.gallery.id
              ),
              pictures: this.state.pictures.filter(
                (e, i) => i != this.state.gallery.id
              ),
              gallery: this.state.demoFiles.length <= 1 ? true : false
            });
          }}
        />
      </Gallery>
    );
  }

  renderDialog() {
    const { showDialog, qrcode, from } = this.state;
    return (
      <div>
        {qrcode ? (
          <WKDialog
            show={showDialog}
            closeText="关闭"
            onClick={this.handleClose}
          >
            <div className="no-subscribed">
              <p className="title">{from === 'lihua'? '咨询':'投诉'}提交成功</p>
              <p className="desc">感谢您的提交，我们将在一个工作日内回复您。</p>
              <p className="desc">【我的消息】查看{from === 'lihua'? '咨询':'投诉'}反馈</p>
              <p className="image">
                <img src={qr(qrcode)} alt="" />
              </p>
            </div>
          </WKDialog>
        ) : (
          <WKDialog
            show={showDialog}
            closeText="点击查看"
            onClick={this.handleClose}
          >
            <div className="no-subscribed">
              <p className="title">{from === 'lihua'? '咨询':'投诉'}提交成功</p>
              <p className="desc">感谢您的提交，我们将在一个工作日内回复您。</p>
              <p className="desc">您也可以进入公众号【我的消息】查看{from === 'lihua'? '咨询':'投诉'}反馈</p>
            </div>
          </WKDialog>
        )}
      </div>
    );
  }

  render() {
    const { link, from } = this.state;
    return (
      <div className="complain-body">
        <CellsTitle>{from === 'lihua'? '咨询':'投诉'}描述</CellsTitle>

        <Form>
          <FormCell>
            <CellBody>
              <TextArea
                placeholder={`请输入${from === 'lihua'? '咨询':'投诉'}内容`}
                rows="5"
                maxlength="200"
                onChange={this.handleReasonChange}
              />
            </CellBody>
          </FormCell>
          <FormCell>
            <CellBody>
              {this.renderGallery()}

              {this.renderDialog()}

              <Uploader
                title={from === 'lihua'? '图片上传（如无咨询图片可不上传）':'证据截图'}
                maxCount={4}
                files={this.state.demoFiles}
                onError={msg => this.context.page.showAlert(msg)}
                onChange={(file, e) => {
                  let newFiles = [...this.state.demoFiles, { url: file.data }];
                  let uploadFile = document.querySelector("input[type=file]")
                    .files[0];
                  this.state.pictures.push(uploadFile);
                  this.setState({
                    demoFiles: newFiles,
                    pictures: this.state.pictures
                  });
                }}
                onFileClick={(e, file, i) => {
                  console.log("file click", file, i);
                  this.setState({
                    gallery: {
                      url: file.url,
                      id: i
                    }
                  });
                }}
                lang={{
                  maxError: maxCount => `最多只能上传 ${maxCount} 张证据截图`
                }}
              />
            </CellBody>
          </FormCell>
          { from !== 'lihua' && 
            <FormCell>
              <CellHeader>
                <Label>证据链接</Label>
              </CellHeader>
              <CellBody>
              <Input
                onChange={e => this.setState({ link: e.target.value })}
                placeholder="选填，提供页面链接以便定位问题"
                value={link}
              />
              </CellBody>
            </FormCell>
          }
          
        </Form>

        <ComplainContact
          isFromQuestion={this.props.isFromQuestion}
          ref="complainContact"
        />

        <div className="submit-btn">
          <Button onClick={this.handleSubmit}>提交</Button>
        </div>
      </div>
    );
  }
}

ComplainBody.contextTypes = {
  page: React.PropTypes.object
};

export default ComplainBody;



// WEBPACK FOOTER //
// ./src/components/complain/ComplainBody.js